/*
 * 百舸云平台权限配置 - 平台权限
 *
 * name                     应用名称
 * version                  应用版本  1.0.0 开始
 * menus                    全部菜单  Array
 *   name                   菜单标识
 *   title                  菜单名称
 *   views                  二级菜单
 *     pc                   pc端  Array
 *       name               菜单标识
 *       title              菜单名称
 *       haveMenuSubpage    一级菜单有子页面
 *       auth               功能权限
 *         name             权限名称
 *         permission       权限值  菜单标识_菜单标识_功能
 *         haveSubpage      二级菜单有子页面
 *         pages            子页面标识  Array
 *
 *     mobile               移动端  Array
 */

export default {
  name: 'BaiGeYun',
  version: '1.0.0',
  menus: [
    {
      name: 'overview',
      title: '概况总览',
      views: {
        pc: [
          {
            name: 'overview',
            title: '概况总览',
            auth: [
              {
                name: '查看',
                permission: 'overview_overview_view'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'factoryManage',
      title: '工厂管理',
      views: {
        pc: [
          {
            name: 'factoryManage',
            title: '工厂管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'factoryManage_view',
                haveSubpage: true,
                pages: ['factoryDetail']
              },
              {
                name: '新增',
                permission: 'factoryManage_add'
              },
              {
                name: '编辑',
                permission: 'factoryManage_edit'
              },
              {
                name: '删除',
                permission: 'factoryManage_delete'
              },
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'deviceManage',
      title: '设备管理',
      views: {
        pc: [
          {
            name: 'deviceManage',
            title: '设备管理',
            haveMenuSubpage: true,
            auth: [
              {
                name: '查看 / 详情',
                permission: 'equipmentCenter_deviceManage_view',
                haveSubpage: true,
                pages: ['deviceDetail']
              },
              {
                name: '新增设备',
                permission: 'equipmentCenter_deviceManage_add'
              },
              {
                name: '同步信息',
                permission: 'equipmentCenter_deviceManage_syncInfo'
              },
              {
                name: '启用 / 禁用设备',
                permission: 'equipmentCenter_deviceManage_use'
              },
              {
                name: '召回设备',
                permission: 'equipmentCenter_deviceManage_callback'
              },
              {
                name: '分享设备',
                permission: 'equipmentCenter_deviceManage_share'
              },
              {
                name: '复制设备',
                permission: 'equipmentCenter_deviceManage_copy'
              },
              {
                name: '删除设备',
                permission: 'equipmentCenter_deviceManage_delete'
              },
              {
                name: '编辑设备',
                permission: 'equipmentCenter_deviceManage_edit'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'energyManage',
      title: '能源管理',
      views: {
        pc: [
          {
            name: 'energySet',
            title: '能源配置',
            auth: [
              {
                name: '查看',
                permission: 'energyManage_energySet_view'
              },
              {
                name: '新增',
                permission: 'energyManage_energySet_add'
              },
              {
                name: '编辑',
                permission: 'energyManage_energySet_modify'
              },
              {
                name: '调价',
                permission: 'energyManage_energySet_changePrice'
              },
              {
                name: '调价记录',
                permission: 'energyManage_energySet_changeRecord'
              },
              {
                name: '删除',
                permission: 'energyManage_energySet_del'
              }
            ]
          },
          {
            name: 'meter',
            title: '计量仪表',
            auth: [
              {
                name: '查看',
                permission: 'energyManage_meter_view'
              },
              {
                name: '新增',
                permission: 'energyManage_meter_add'
              },
              {
                name: '编辑',
                permission: 'energyManage_meter_edit'
              },
              {
                name: '删除',
                permission: 'energyManage_meter_delete'
              }
            ]
          },
          {
            name: 'energyUsePlan',
            title: '用能计划',
            auth: [
              {
                name: '查看',
                permission: 'energyManage_energyUsePlan_view'
              },
              {
                name: '保存',
                permission: 'energyManage_energyUsePlan_save'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'reportAnalysis',
      title: '报表分析',
      views: {
        pc: [
          {
            name: 'costAnalysis',
            title: '成本分析',
            auth: [
              {
                name: '查看',
                permission: 'reportAnalysis_costAnalysis_view'
              },
            ],
          },
          {
            name: 'planAssess',
            title: '计划考核',
            auth: [
              {
                name: '查看',
                permission: 'reportAnalysis_planAssess_view'
              },
            ],
          }
        ],
        mobile: []
      },
    },
    {
      name: 'energyStatic',
      title: '能源统计',
      views: {
        pc: [
          {
            name: 'energyTrend',
            title: '能源流向',
            auth: [
              {
                name: '查看',
                permission: 'energyStatic_energyTrend_view'
              },
            ],
          },
          {
            name: 'energyUseStatic',
            title: '用能统计',
            auth: [
              {
                name: '查看',
                permission: 'energyStatic_energyUseStatic_view'
              },
            ],
          }
        ],
        mobile: []
      },
    },
    {
      name: 'resourceManage',
      title: '资源管理',
      views: {
        pc: [
          {
            name: 'gatewayManage',
            title: '网关管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'gatewayManage_gatewayManage_view',
                haveSubpage: true,
                pages: ['gatewayDetail']
              },
              {
                name: '网关入库',
                permission: 'gatewayManage_gatewayManage_entry'
              },
              {
                name: 'HiVPN',
                permission: 'gatewayManage_gatewayManage_HiVPN'
              },
              {
                name: '删除',
                permission: 'gatewayManage_gatewayManage_delete'
              }
            ]
          },
          {
            name: 'spaceManage',
            title: '空间管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'spaceManage_spaceManage_view'
              },
              {
                name: '清除数据',
                permission: 'spaceManage_spaceManage_clearData'
              },
              {
                name: '预警设置',
                permission: 'spaceManage_spaceManage_alarmSet'
              },
              {
                name: '刷新',
                permission: 'spaceManage_spaceManage_refresh'
              }
            ]
          },
          {
            name: 'messageManage',
            title: '短信管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'smsManage_smsOverview_view'
              },
              {
                name: '重新发送',
                permission: 'smsManage_smsOverview_resend'
              },
              {
                name: '预警设置',
                permission: 'smsManage_smsOverview_warnSet'
              }
            ]
          },
          {
            name: 'iotCardManage',
            title: '物联卡管理',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'iotCardManage_cardList_view'
              },
              {
                name: '续费套餐',
                permission: 'iotCardManage_cardList_rebuy'
              },
              {
                name: '预警设置',
                permission: 'iotCardManage_cardList_warnSet'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'dataLargeScreen',
      title: '数据大屏',
      views: {
        pc: [
          {
            name: 'my',
            title: '我的大屏',
            auth: [
              {
                name: '查看',
                permission: 'dataLargeScreen_my_view'
              },
              {
                name: '操作',
                permission: 'dataLargeScreen_my_operate'
              }
            ]
          },
          {
            name: 'template',
            title: '模板中心',
            auth: [
              {
                name: '查看',
                permission: 'dataLargeScreen_template_view'
              }
            ]
          },
          {
            name: 'dataSource',
            title: '数据源',
            auth: [
              {
                name: '查看',
                permission: 'dataLargeScreen_dataSource_view'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'organizationManage',
      title: '组织机构',
      views: {
        pc: [
          {
            name: 'companyManage',
            title: '企业信息',
            auth: [
              {
                name: '查看',
                permission: 'organizationManage_companyManage_view'
              },
              {
                name: '修改',
                permission: 'organizationManage_companyManage_modify'
              }
            ]
          },
          {
            name: 'userManage',
            title: '用户管理',
            auth: [
              {
                name: '查看',
                permission: 'organizationManage_userManage_view'
              },
              {
                name: '新增部门 / 编辑部门',
                permission: 'organizationManage_userManage_addAndModifyOrganization'
              },
              {
                name: '删除部门',
                permission: 'organizationManage_userManage_deleteOrganization'
              },
              {
                name: '用户账号管理',
                permission: 'organizationManage_userManage_userAccountManage'
              },
              {
                name: '部门管理',
                permission: 'department_manage',
                haveSubpage: true,
                pages: ['departmentManage']
              }
            ]
          },
          {
            name: 'roleManage',
            title: '角色管理',
            auth: [
              {
                name: '查看',
                permission: 'organizationManage_roleManage_view'
              },
              {
                name: '新增角色 / 编辑角色',
                permission: 'organizationManage_roleManage_addAndModify',
                haveSubpage: true,
                pages: ['addOrModifyRole']
              },
              {
                name: '推送设置',
                permission: 'organizationManage_roleManage_pushSet'
              },
              {
                name: '启用 / 禁用',
                permission: 'organizationManage_roleManage_onAndOff'
              },
              {
                name: '删除',
                permission: 'organizationManage_roleManage_delete'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'notice',
      title: '消息中心',
      views: {
        pc: [
          {
            name: 'notice',
            title: '消息中心',
            auth: [
              {
                name: '查看',
                permission: 'notice_notice_view'
              }
            ]
          }
        ],
        mobile: []
      }
    },
    {
      name: 'systemManage',
      title: '系统管理',
      views: {
        pc: [
          {
            name: 'systemLogs',
            title: '系统日志',
            auth: [
              {
                name: '查看 / 详情',
                permission: 'systemManage_systemLogs_view'
              }
            ]
          },
          {
            name: 'systemSet',
            title: '系统设置',
            auth: [
              {
                name: '查看',
                permission: 'systemManage_systemSet_view'
              },
              {
                name: '基本设置',
                permission: 'systemManage_systemSet_basicSet'
              },
              {
                name: '安全设置',
                permission: 'systemManage_systemSet_safetySet'
              },
              {
                name: '运维设置',
                permission: 'systemManage_systemSet_operationsSet'
              },
              {
                name: '登录页设置',
                permission: 'systemManage_systemSet_loginSet'
              }
            ]
          },
          {
            name: 'mobileSetting',
            title: '移动端设置',
            auth: [
              {
                name: '查看',
                permission: 'mobileSetting_mobileSetting_view'
              },
              {
                name: '基本信息',
                permission: 'mobileSetting_mobileSetting_basicSet'
              },
              {
                name: '广告图管理',
                permission: 'mobileSetting_mobileSetting_bannerSet'
              },
              {
                name: '关于我们',
                permission: 'mobileSetting_mobileSetting_aboutSet'
              }
            ]
          }
        ],
        mobile: []
      }
    }
  ]
};
